import { Injectable } from '@angular/core';
import { ActionInBookingType, ActionType } from "@afidium/ts-facade";
import { EServiceQualityEnum } from "../resources/airQuote/airQuoteResource.service";

@Injectable()
export class ActionQualityHelperService {

    public extractActionByQualificationForQuotedAvailabilityTrip(actionArray: ActionType[], qualification: EServiceQualityEnum): ActionInBookingType {
        if(!actionArray?.length){
            return null;
        }
        const quoteAction: ActionType = actionArray
            .find((action: ActionType): boolean => action.xCode === "QuotedAvailability");

        if (quoteAction) {
            const tripAction: ActionInBookingType = (quoteAction.actionArray || [])
                .find((action: ActionInBookingType): boolean => action.xCode === "Trip"&& !action.xMatch);

            if (tripAction && tripAction.actionArray && tripAction.actionArray.length) {
                return tripAction.actionArray
                    .find((action: ActionInBookingType): boolean => action.qualification === qualification);
            }
            return null;
        }

        return null;
    }

    public extractActionsForQuotedAvailabilityTrip(actionArray: ActionType[]): ActionInBookingType[]{
        if(!actionArray?.length){
            return null;
        }
        const quoteAction: ActionType = actionArray
            .find((action: ActionType): boolean => action.xCode === "QuotedAvailability");

        if (quoteAction && quoteAction.actionArray) {
            const tripAction: ActionInBookingType = quoteAction.actionArray
                .find((action: ActionInBookingType): boolean => action.xCode === "Trip" && !action.xMatch);
            return tripAction?.actionArray;
        }
        return null;
    }
}
